module.exports = __webpack_public_path__ + "static/media/caramel apple 1 600x600.77753b9c.png";